/**
 * Содержит информацию о запущенных задачах
 */
export class JobInfo<T> {
  /**
   * Название задачи
   */
  public name: string;

  /**
   * Группа, к которой задача принадлежит
   */
  public group?: string;

  /**
   * Параметры задачи (JSON)
   */
  public parameters?: T;

  /**
   * Время следующего выполнения
   */
  public nextTimeFire?: Date;

  /**
   * Временно остановлена
   */
  public paused?: boolean;

  /**
   * Интервал выполнения
   */
  public interval: string;

  /**
   * Определяет, запрещено ли одновременное выполнение задачи
   */
  public concurrentExecutionDisallowed?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/storedJob/jobInfo.model.ts